import { render } from "./AdBanner.vue?vue&type=template&id=39e1ce98&scoped=true"
import script from "./AdBanner.vue?vue&type=script&lang=js"
export * from "./AdBanner.vue?vue&type=script&lang=js"

import "./AdBanner.vue?vue&type=style&index=0&id=39e1ce98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e1ce98"]])

export default __exports__